// apiClient.js
import axios from 'axios';
import { server_api } from '../utils/constants';

const apiClient = axios.create({
  baseURL: server_api(),  // The base URL for your API
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor to add the auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    // config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;